import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import axios from "../../../axios/axios";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../utils/adminConfig";

const DashboardCertificateAvailable = () => {
  const [certificate, setCertificate] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCertificates = () => {
    setLoading(true);
    axios
      .get(`/get-all-certificate-with-code-count`, adminConfig())
      .then((res) => {
        setCertificate(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getCertificates();
  }, []);

  return (
    <LoadingOverlay
      active={loading}
      spinner
      text="Loading ..."
      className="lodOvrlay"
    >
      <Row>
        <Col md="12">
          <h2>Available Certificate Codes</h2>
        </Col>
        {certificate.map((res, key) => {
          if (res.certificateId === "TVIACCESSPLUSRESTAURANT") return null;

          const {
            certificateId,
            certificateImg,
            certificateCodesCount,
            certificateLimitCount,
          } = res;

          const isLow = certificateCodesCount <= certificateLimitCount;

          return (
            <Col md="3" className="right_innrBanner" key={key}>
              <div className="right_inner_inner_banner">
                <a
                  href={`/bulk-upload/${certificateId}`}
                  className="banner_box"
                >
                  <img src={certificateImg} className="img-fluid" alt="" />
                </a>
                <p
                  className={
                    isLow
                      ? "available_certificate_count_lower_text"
                      : "available_certificate_count_text"
                  }
                >
                  Available Certificate{" "}
                  {certificateCodesCount > 1 ? "Codes" : "Code"}:{" "}
                  {certificateCodesCount}
                </p>
              </div>
            </Col>
          );
        })}
      </Row>
    </LoadingOverlay>
  );
};

export default DashboardCertificateAvailable;
